<template>
  <ul class="add-list list">
    <li class="combine-item"
        v-if="permission > 3">
      <button type="button"
              @click="showAddRole"
              class="list-item">
        {{$t('projects.project.addRole')}}
        <plusIcon :fill="'rgba(0, 82, 127, .4)'"></plusIcon>
      </button>
    </li>
    <li class="combine-item"
        v-if="permission > 1 && adminRole">
      <button type="button"
              v-if="!isMotherPage"
              @click="showAddThing"
              class="list-item">
        {{$t('projects.project.addThing')}}
        <plusIcon :fill="'rgba(0, 82, 127, .4)'"></plusIcon>
      </button>
    </li>
    <li class="combine-item"
        v-if="permission > 1">
      <button type="button"
              @click="showAddProject"
              class="list-item">
        {{$t('projects.project.addSection')}}
        <plusIcon :fill="'rgba(0, 82, 127, .4)'"></plusIcon>
      </button>
    </li>
  </ul>
</template>

<script>
  import plusIcon from  '../../../Svg/plusIcon'

  import {mapGetters, mapMutations} from 'vuex'
  import {showOverlay} from "../../../../mixins/utils/showOverlay";

  export default {
    name: 'addList',
    props: {
      isVirtual: {
        type: Boolean,
        default: false
      },
      permission: [Number, String]
    },
    mixins: [showOverlay],
    components: {plusIcon},
    computed: {
      ...mapGetters({
        adminRole: 'auth/adminRole'
      }),
      isMotherPage() {
        return this.$route.name === 'project-edit'
      },
    },
    methods: {
      ...mapMutations({
        showAddThingPopup: 'projects/SET_ADD_THING_IN_PROJECT',
        setType: 'popups/addThing/SET_TYPE',
        showAddPermissionProject: 'projects/SET_SHOW_ADD_PERMISSION',

        showAddSection: 'projects/SET_SHOW_ADD_SECTION',
        setAddId: 'projects/SET_ADD_SECTION_ID_CHILD'
      }),
      showAddRole() {
        this.showOverlay(true);
        this.showAddPermissionProject(true)
      },
      showAddThing(param) {
        this.showOverlay(true);
        this.showAddThingPopup(true);
      },
      showAddProject() {
        this.showOverlay(true);
        this.showAddSection(true);
        addIdSection(this);

        function addIdSection(cntx) {
          const itemId = cntx.$route.params.item;

          if (itemId) {
            cntx.setAddId(itemId)
          };
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .combine-item {
    width: 240px;
  }


</style>
